import React, { useState } from 'react';
import taskServices from '../taskServices';
import { useAppData } from '../../../../../context/AppDataContext';
import TaskProgressGauge from './editor/TaskProgressGuage';
import TaskDetailsView from './TaskDetailsView';
import TaskStatusBadge from './editor/TaskStatusBadge';
import PriorityBadge from './editor/PriorityBadge';
import TaskScheduleBadge from './editor/TaskScheduleBadge';

function TaskCardListView({ taskList, callBack }) {
    const [taskDetails, setTaskDetails] = useState(null);
    const { projectDD, userDD, getDDDataById } = useAppData();

    const handleCallBack = () => {
        setTaskDetails(false);
        callBack();
    }

    return (
        <div className="container-fluid p-2">
            <div className='row'>
            {taskList && taskList.map(task => {
                // Safety check for the border class
                const statusBorderClass = taskServices?.statusBorderColorClass?.[task.taskStatus] || "border-secondary";

                return (
                    <div className='col-md-3 px-1'>
                    <div 
                        key={task.id}
                        onClick={() => setTaskDetails(task)}
                        className={`card mb-3  shadow-sm border-top-0 border-end-0 border-bottom-0 task-card-hover ${statusBorderClass}`}
                        style={{ 
                            borderRadius: '10px', 
                            borderLeft: '6px solid', 
                            cursor: 'pointer' 
                        }}
                    >
                        <div className="card-body p-3" >
                            {/* 1. Main Title & Subtitle */}
                            <div className="mb-3" style={{maxWidth:280}}>
                            
                                <div className="mb-0" style={{ overflow:"hidden", textOverflow:"ellipsis",whiteSpace:"nowrap"}} >
                                    <span className='fw-bold'>
                                        {taskServices?.typeIcons?.[task.calendarType]} {task.title}
                                    </span>
                                    <sapn className="text-muted small">-{getDDDataById(userDD, task.userId)?.firstName}</sapn>
                                </div>
                                <div className="text-muted small" >
                                    {task.projectId ? getDDDataById(projectDD, task.projectId)?.label : ""}
                                </div>
                            </div>

                            {/* 2. Body: Left (Status/Priority) & Right (Gauge) */}
                            <div className="row align-items-center mb-3">
                                <div className="col-8">
                                    <div className="d-flex flex-column gap-2">
                                        <div className=""><TaskStatusBadge value={task.taskStatus} /></div>
                                        <div className=""><PriorityBadge value={task.priority} /></div>
                                    </div>
                                </div>
                                <div className="col-4 text-end">
                                    <TaskProgressGauge value={task.progress} height={75} width={75} />
                                </div>
                            </div>

                            {/* 3. Footer: Bottom Left (Assignee) & Bottom Right (Due Date) */}
                            <div className="pt-2 border-top d-flex justify-content-between align-items-center">
                                <div className="small">
                                    <span className="text-muted">Assignee: </span>
                                    <span className="fw-bold">{getDDDataById(userDD, task.assignedTo)?.firstName || "Unassigned"}</span>
                                </div>
                                <div>
                                    <TaskScheduleBadge 
                                        startDate={task.startDate}
                                        startTime={task.startTime}
                                        endDate={task.endDate}
                                        endTime={task.endTime}
                                    />
                                </div>
                            </div>
                        </div>
                    </div>
                    </div>
                );
            })}
            </div>

            <TaskDetailsView 
                taskDetails={taskDetails} 
                setTaskDetails={setTaskDetails} 
                callBack={handleCallBack} 
            />
        </div>
    );
}

export default TaskCardListView;